import { SET_MAP_DEFAULT_STATE, SET_MAP_STATE, SET_MAP_ZOOM, SET_MAP_CENTER, SET_MAP_EXTENT, ADD_MAP_ZOOM, MAP_MOVE_END, SET_MAP_ROTATION, } from '../constants';
import { getInitialState } from './initialState';
const validateRotation = (rotation) => {
    return ((rotation + Math.PI) % (2 * Math.PI)) - Math.PI;
};
export const view = (state = getInitialState().view, action) => {
    switch (action.type) {
        case SET_MAP_DEFAULT_STATE: {
            return getInitialState().view;
        }
        case SET_MAP_STATE: {
            return {
                ...state,
                ...action.payload.view,
            };
        }
        case SET_MAP_ZOOM: {
            let zoom = action.payload;
            if (state.maxZoom < zoom) {
                zoom = state.maxZoom;
            }
            if (state.minZoom > zoom) {
                zoom = state.minZoom;
            }
            return {
                ...state,
                zoom,
                setExtent: undefined,
            };
        }
        case ADD_MAP_ZOOM: {
            let zoom = state.zoom + action.payload;
            if (state.maxZoom < zoom) {
                zoom = state.maxZoom;
            }
            if (state.minZoom > zoom) {
                zoom = state.minZoom;
            }
            return {
                ...state,
                zoom,
                setExtent: undefined,
            };
        }
        case SET_MAP_CENTER: {
            return {
                ...state,
                center: action.payload,
                setExtent: undefined,
            };
        }
        case SET_MAP_EXTENT: {
            return {
                ...state,
                setExtent: { ...action.payload },
            };
        }
        case SET_MAP_ROTATION: {
            return {
                ...state,
                rotation: validateRotation(action.payload),
            };
        }
        case MAP_MOVE_END: {
            return {
                ...state,
                ...action.payload,
                setExtent: undefined,
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=viewReducer.js.map